import { createContext } from "react";
import { ThemeContext } from "../context/themeContext";

class TokenService {
  getLocalRefreshToken() {
    const user = JSON.parse(localStorage.getItem("user"));
    return user ? user.refreshToken : null;
  }

  getLocalAccessToken() {
    const user = JSON.parse(localStorage.getItem("userDetails"));
    return user ? user.token : null;
  }

  updateLocalAccessToken(token) {
    let user = JSON.parse(localStorage.getItem("user"));
    user.accessToken = token;
    localStorage.setItem("user", JSON.stringify(user));
  }

  getUser() { return JSON.parse(localStorage.getItem("user"));}

  setUser(user) { localStorage.setItem("user", JSON.stringify(user));}

  removeUser() {
    localStorage.removeItem("user");
  }

  decode(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }
}

export default new TokenService();
